import SurveyAPI from '@/apis/business/student/survey-api.js'

export default {
  namespaced: true,

  state: {

  },

  getters: {},

  mutations: {

  },

  actions: {
    insertSurvey (context, params) {
      return new Promise((resolve, reject) => {
        SurveyAPI.postAsync('survey-param', params)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Check xem đã khảo sát hay chưa
     * @returns
     */
    checkSurvey (context, params) {
      return new Promise((resolve, reject) => {
        SurveyAPI.getAsync(`check-survey/${params}`)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
